module.exports = __webpack_public_path__ + "static/media/silver-shoe-box.55d6a7f8.png";